import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {AUTH_TOKEN} from 'constants/AuthConstant';
import AuthService from 'services/AuthService';

import {setAccess, setConfigs, setCountry, setDevise, setLanguage} from "../../components/permissions/functions";

export const initialState = {
    client: null,
    access: null,
    loading: false,
    message: '',
    showMessage: false,
    redirect: '',
    token: localStorage.getItem(AUTH_TOKEN) || null
}

export const signIn = createAsyncThunk('access/login', async (data, {rejectWithValue}) => {
    const {email, pwd} = data
    try {
        const response = await AuthService.login({email, pwd})
        const token = response.token;
        const client = response.client
        const access = response.access
        localStorage.setItem(AUTH_TOKEN, token);

        return {token, client, access};
    } catch (err) {
        return rejectWithValue(err.response?.message || 'Error')
    }
})


export const signOut = createAsyncThunk('access/logout', async () => {
    //const response = await AuthService.logout()
    localStorage.removeItem(AUTH_TOKEN);
    //return response.data
})


export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        updateClient: (state, action) => {
            state.client = action.payload
        },
        updateAccess: (state, action) => {
            state.access = action.payload
        },
        authenticated: (state, action) => {
            state.loading = false
            state.redirect = '/'
            state.token = action.payload.token
            state.client = action.payload.client
            state.access = action.payload.access
        },
        showAuthMessage: (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        },
        hideAuthMessage: (state) => {
            state.message = ''
            state.showMessage = false
        },
        signOutSuccess: (state) => {
            state.loading = false
            state.token = null
            state.client = null
            state.access = null
            state.redirect = '/'
        },
        showLoading: (state) => {
            state.loading = true
        },
        signInSuccess: (state, action) => {
            state.loading = false
            state.token = action.payload.token
            state.client = action.payload.client
            state.access = action.payload.access
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(signIn.pending, (state) => {
                state.loading = true
            })
            .addCase(signIn.fulfilled, (state, action) => {
                state.loading = false
                state.redirect = '/'
                state.token = action.payload.token
                state.client = action.payload.client
            })
            .addCase(signIn.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })
            .addCase(signOut.fulfilled, (state) => {
                state.loading = false
                state.token = null
                state.redirect = '/'
            })
            .addCase(signOut.rejected, (state) => {
                state.loading = false
                state.token = null
                state.redirect = '/'
            })
    },
})

export const {
    updateClient,
    updateAccess,
    authenticated,
    showAuthMessage,
    hideAuthMessage,
    signOutSuccess,
    showLoading,
    signInSuccess
} = authSlice.actions

export default authSlice.reducer
